"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _command = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/command"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var PlaceholderCommand = /*#__PURE__*/function (_Command) {
  (0, _inherits2["default"])(PlaceholderCommand, _Command);

  var _super = _createSuper(PlaceholderCommand);

  function PlaceholderCommand() {
    (0, _classCallCheck2["default"])(this, PlaceholderCommand);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(PlaceholderCommand, [{
    key: "execute",
    value: function execute(_ref) {
      var value = _ref.value;
      var editor = this.editor;
      var selection = editor.model.document.selection;
      editor.model.change(function (writer) {
        // Create a <placeholder> elment with the "name" attribute (and all the selection attributes)...
        var placeholder = writer.createElement('placeholder', _objectSpread(_objectSpread({}, Object.fromEntries(selection.getAttributes())), {}, {
          name: value
        })); // ... and insert it into the document.

        editor.model.insertContent(placeholder); // Put the selection (caret/cursor) after the inserted element.

        writer.setSelection(placeholder, 'after');
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var selection = model.document.selection;
      var isAllowed = model.schema.checkChild(selection.focus.parent, 'placeholder');
      this.isEnabled = isAllowed;
    }
  }]);
  return PlaceholderCommand;
}(_command["default"]);

exports["default"] = PlaceholderCommand;
//# sourceMappingURL=placeholdercommand.js.map